import {HttpClient} from "../../service/httpClient/HttpClient";

export class OccasionalService {
    constructor() {
        this.httpclient = new HttpClient()
    }


    getBannerItems(page, size) {
        return new Promise((resolve, reject) => {
            this.httpclient.get(
                `occasional-banners`,
                {
                    page,size
                }
            ).then(resolve).catch(reject)
        })
    }

    createNewBanner(title, slug, priority) {
        return new Promise((resolve, reject) => {
            this.httpclient.post(
                `occasional-banners`,
                {
                    title,
                    slug,
                    priority
                }
            ).then(resolve).catch(reject)
        })
    }

    getBannerDetailById(id) {
        return new Promise((resolve, reject) => {
            this.httpclient.get(
                `occasional-banners/${id}/information`
            ).then(resolve).catch(reject)
        })
    }

    getBannerThumbnailById(id) {
        return new Promise((resolve, reject) => {
            this.httpclient.get(
                `occasional-banners/${id}/thumbnails`
            ).then(resolve).catch(reject)
        })
    }

    updateThumbnail(id, photoFile) {
        let data = new FormData()
        data.append('file', photoFile)


        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "multipart/form-data"
            ).patch(
                `occasional-banners/${id}/thumbnails`,
                {},
                data
            ).then(resolve).catch(reject)

        })
    }

    getBannerPublishedStateById(id) {
        return new Promise((resolve, reject) => {
            this.httpclient.get(
                `occasional-banners/${id}/published`
            ).then(resolve).catch(reject)
        })
    }

    changePublishedState(id, published) {
        return new Promise((resolve, reject) => {
            this.httpclient.patch(
                `occasional-banners/${id}/published`,
                {},
                {
                    published
                }
            ).then(resolve).catch(reject)
        })
    }

    updateDetail(id, title, slug, startDate, endDate, priority, description) {
        return new Promise((resolve, reject) => {
            this.httpclient.put(
                `occasional-banners/${id}/information`,
                {
                    title,
                    description,
                    slug,
                    startDate,
                    endDate,
                    priority
                }
            ).then(resolve).catch(reject)
        })
    }
}